<template>
  <div>
    <b-row>
      <b-modal id="modal-assign" hide-footer ref="escalateSubmissions" title="Escalate Data Update">
        <EscalationDataUpdate :application-id="task.applicationId" :level="2" type="ci-data-update" permission="can_view_company_data_update_escalations"/>
      </b-modal>
    </b-row>
    <b-modal id="modal-confirm" hide-footer ref="confirm" title="Confirm">
      <b-row>
        <b-col>
          <p class="text-sm">
            <span class="h6">Are you sure you are ready to take this action?</span>.<br/>
            This action can only be reversed by your superiors. Only confirm if you are certain that this is the appropriate Final Decision
          </p>
          <p class="mt-3 text-sm italic">
            <b>Note:</b><br/>
            All actions performed on <b class="text-blue">URSB eRegistry</b> are recorded and details of the account that initiated are tagged to the action.
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="cancelConfirmation">
            <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
        </b-col>
        <b-col cols="4"></b-col>
        <b-col cols="4">
          <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="yesConfirmation">
            <i class="fa fa-check-circle text-white mr-1"></i> Accept <b-spinner small v-if="loading"></b-spinner></button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-query" hide-footer ref="query-incorporation" title="Query Submission">
      <b-col cols="12">
        <b-form class="w-full">
          <b-form-textarea
            v-model="form.description"
            type="text"
            placeholder="Give description of query"
            class="mt-1"
            required>
          </b-form-textarea>
          <p v-if="form.description" class="my-2 text-xs">{{form.description.length}}/{{maxText}}</p>
          <b-row>
            <b-col cols="4">
              <b-button class="btn-query-hover" variant="primary" @click="onQuery">
                Query
                <b-spinner small v-if="loading"></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-modal>
    <b-row class="mx-1">
      <b-col cols="12">
        <b-row class="mx-1">
          <b-col>
            <CompanyDataUpdateMessages :task="task" mode="TOP_MESSAGE"/>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-alert variant="success" show>
              <i class="fa fa-info-circle mx-1"></i> This application was fully approved on <b>Verification Level 1</b>. Go through it once again to ensure that nothing has been left unchecked.
              This is a security mechanism to allow a testimony of more than one so that we have a thorough check of every entity before it is updated on the platform
            </b-alert>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col>
            <span style="font-size: 30px; font-weight: bold">
              {{task.applicationResponse.name}} <label v-if="task.applicationResponse.nameOnFile" class="mx-1 text-blue">( Name on File:  {{task.applicationResponse.nameOnFile}} )</label>
            </span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead>
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2">Update Details</td>
              </tr>
              <tr>
                <th class="px-2 py-1">Tracking Number</th>
                <th class="px-2 py-1">Registration Number</th>
                <th class="px-2 py-1">Status</th>
                <th class="px-2 py-1">Sub Entity Type</th>
                <th class="px-2 py-1">Level</th>
                <th class="px-2 py-1">Submission Date</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #dedede;" >
                <td class="px-2 py-1">
                  <span class="text-gray">
                    {{task.trackingNo}}
                  </span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray">
                    {{task.applicationResponse.brn}}
                  </span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-blue text-capitalize">{{task.status.toLowerCase()}}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray text-capitalize">{{cleanEntityType(task.applicationResponse.subType)}}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray text-capitalize">Level {{task.applicationResponse.applicationLevel}}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray italic">
                    {{dateTimeFormat(task.applicationResponse.submissionDate)}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead>
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2">Summary</td>
              </tr>
              </thead>
              <tbody>

              <tr style="border: solid 1px #dedede;" >
                  <td class="px-2 py-1 font-bold">
                      Date of Registration in Uganda
                  </td>
                  <td class="px-2 py-1">
                  <span class="text-gray">
                   {{dateFormat(task.applicationResponse.registrationDate)}}
                  </span>
                  </td>
              </tr>
              <tr style="border: solid 1px #dedede;" v-if="task.applicationResponse.subType === 'foreign-company'">
                  <td class="px-2 py-1 font-bold">

                      Date of Incorporation in the country of origin
                  </td>
                  <td class="px-2 py-1">
                  <span class="text-gray">
                   {{dateFormat(task.form24.foreignIncorporationDate)}}
                  </span>
                  </td>
              </tr>

              <tr style="border: solid 1px #dedede;" >
                <td class="px-2 py-1 font-bold">
                  Last filed Annual Returns
                </td>
                <td class="px-2 py-1">
                  <pre class="text-gray">
                   {{task.lastYearFiled}}
                  </pre>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <table class="min-w-full leading-normal mt-1 text-blue-dark"
                   style="border: solid 1px #bdd7f1;">
              <thead>
              <tr class="bg-blue-pale">
                <td colspan="12" class="px-2 py-2 font-bold">Applicant Details</td>
              </tr>
              <tr>
                <th class="px-2 py-1">Name</th>
                <th class="px-2 py-1">Email</th>
                <th class="px-2 py-1">Phone</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #bdd7f1;">
                <td class="px-2 py-1 text-capitalize">{{task.applicationResponse.applicant.givenName}} {{task.applicationResponse.applicant.surname}}</td>
                <td class="px-2 py-1">{{task.applicationResponse.applicant.email}}</td>
                <td class="px-2 py-1">{{task.applicationResponse.applicant.phoneNumber}}</td>
              </tr>
              </tbody>
            </table>
          </b-col>
          <b-col cols="6">
            <table class="min-w-full leading-normal mt-1 text-blue-dark"
                   style="border: solid 1px #bdd7f1;">
              <thead>
              <tr class="bg-blue-pale">
                <td colspan="12" class="px-2 py-2 font-bold">Official Account Details (To be Created)</td>
              </tr>
              <tr>
                <th class="px-2 py-1">Email</th>
                <th class="px-2 py-1">Phone</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #bdd7f1;">
                <td class="px-2 py-1">
                  {{task.primaryEmail}}
                </td>
                <td class="px-2 py-1">
                  {{task.primaryPhone}}
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col cols="12" md="4" lg="6"></b-col>
          <b-col cols="12" md="8" lg="6">
            <div class="flex float-end">
              <button class="btn-escalate" @click="escalatePrompt">
                <i class="fa fa-arrow-up text-blue mr-1"></i>Escalate
              </button>
              <button type="button" class="btn-query" v-b-modal.modal-query>
                <i class="fa fa-question text-white mr-1"></i> Query
              </button>
              <button type="button" class="btn-approve" @click="onApprove">
                <i class="fa fa-check-circle text-white mr-1"></i> Approve
              </button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <div class="flex h-full" style="cursor: pointer;">
                  <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                    <div class="flex mt-6">
                      <div style="font-size: 14px">Company Information</div>
                    </div>
                  </div>
                  <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                    <div class="flex mt-6">
                      <div style="font-size: 14px">Attachments</div>
                    </div>
                  </div>
                  <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                    <div class="flex mt-6">
                      <div style="font-size: 14px">Messages</div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <CompanyDataUpdateForms v-if="currentRoute === 'forms'" :task="task"/>
                <CompanyDataUpdateFormFiles v-if="currentRoute === 'attachments'" :task="task"/>
                <CompanyDataUpdateMessages v-if="currentRoute === 'messages'" :task="task" mode="THREAD"/>
              </b-col>
              <b-col cols="6">
                <EMDSFileExplorer :brn="task.applicationResponse.brn" :entity-type="task.applicationResponse.type"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import CompanyDataUpdateForms from "@/views/home/services/data-update/task/company/CompanyDataUpdateForms.vue";
import CompanyDataUpdateFormFiles from "@/views/home/services/data-update/task/company/CompanyDataUpdateFormFiles.vue";
import CompanyDataUpdateMessages from "@/views/home/services/data-update/task/company/CompanyDataUpdateMessages.vue";
import EMDSFileExplorer from "@/views/home/services/data-update/components/EMDSFileExplorer.vue";
import EscalationDataUpdate from "@/views/home/commons/EscalationDataUpdate.vue";

export default {
  name: "CompanyDataUpdateTaskLevel2",
  components: { EscalationDataUpdate, EMDSFileExplorer, CompanyDataUpdateMessages, CompanyDataUpdateFormFiles,
    CompanyDataUpdateForms},
  props:{
    task:Object
  },
  data(){
    return{
      margin:"2px",
      currentRoute: "forms",
      loading:false,
      messages:[],
      taskId:null,
      maxText:500,
      snapshot:null,
      snapshots:[],
      form:{
        applicationId:null,
        description:null,
        status:null
      },
    }
  },
  methods:{
    ...mapActions(["updateCompanyDataUpdateStatus"]),
    onApprove(){
      this.form.applicationId = this.task.applicationId
      this.form.status = "APPROVED"
      this.action = "final"
      this.$refs.confirm.show();
    },
    onQuery(){
      this.form.applicationId = this.task.applicationId
      this.form.status = "QUERIED"
      this.action = "final"
      if(this.form.description != null){
        this.$refs.confirm.show();
      }else{
        this.errorToast("Missing Information", "Provide a message for this final decision")
      }
    },
    select(route){
      this.currentRoute = route
    },
    yesConfirmation(){
      if(this.action === "final"){
        this.loading = true
        this.updateCompanyDataUpdateStatus(this.form)
      }
      if(this.action === "escalate"){
        this.$refs.escalateSubmissions.show();
      }
      this.cancelConfirmation()
    },
    cancelConfirmation(){
      this.action = null
      this.$refs.confirm.hide();
    },
    escalatePrompt(){
      this.action = "escalate"
      this.$refs.confirm.show();
    },
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    dateTimeFormat(date){
      return moment(date).format("DD-MM-YYYY HH:mm")
    },
    canViewActionWithPermission(permission) {
      return this.$can(permission, "general") === true;
    }
  },
  computed:{
    ...mapGetters([
      "getDataUpdateStatusSuccess",
      "getDataUpdateCompanyUpdateStatusError",
      "getCompanyDataUpdateTaskError",
        "getCompanyDataUpdateError"
    ])
  },
  watch:{
    getCompanyDataUpdateTaskError(data){
      this.loading = false
      this.errorToast("Error", data.messages)
    },
    getDataUpdateStatusSuccess(){
      this.loading = false
      this.successToast("Success!", "Final Decision Successful")
      window.location.reload()
    },
    getCompanyUpdateStatusSuccessError(){
      this.loading = false
    },
      getCompanyDataUpdateError(error){
          this.errorToast("Data Update Error", error.data.message);
      }
  }
}
</script>

<style scoped>

.icon{
  width: 170px;
}

th, td{
  font-size: 12px;
}

.btn-escalate{
  @apply border border-blue rounded-sm text-blue text-sm px-3 py-1 mx-1 bg-white;
}

.btn-escalate:hover{
  @apply text-blue-dark;
}

.btn-approve{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-query{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-cancel{
  @apply border border-blue bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1;
}

.btn-approve:hover{
  @apply bg-green border-green text-white;
}

.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.btn-cancel:hover{
  @apply bg-red border-red text-white;
}

.btn-approve-hover{
  @apply bg-green border-green text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-query-hover{
  @apply bg-orange border-orange text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-approve-hover:hover{
  @apply bg-green-dark;
}

.btn-query-hover:hover{
  @apply bg-orange-dark;
}

</style>